export default {
    StockStructureConfiguration: {
        Header: {
          Name: 'Warehouse Structure Configuration Name',
          Status: 'Warehouse Structure Configuration Status',
          Create: 'Create',
          Action: 'Configuration',
          Cancel: 'Remove from Listing',
          Publish: 'Publish',
        },
        table: {
          Code: 'Warehouse Structure Configuration Code',
          Name: 'Warehouse Structure Configuration Name',
          status: 'Warehouse Structure Configuration Status',
          Release: 'Publish Status',
          by: 'Created By',
          time: 'Created Time',
          Action: 'Action'
        },
        Form: {
          Create: 'Create Warehouse Structure Configuration',
          Code: 'Warehouse Structure Configuration Code',
          pps: 'Warehouse Structure Configuration Name',
          Name: 'System Generated',
          ps: 'Please enter the warehouse structure configuration name',
        }
    }
};
